<template>
  <div class="education-list-page">
    <div class="filter-box">
      <Btn
        :btnText="'添加' + $eduType"
        className="primary_plain"
        :fontSize="14"
        :width="103"
        :height="37"
        class="create-btn"
        @handleClick="handCreate"
      />
    </div>
    <div class="filter-box">
      <el-input v-model="listQuery.keyWord" round placeholder="编号、名称" style="width: 217px" class="filter-item" />
      <el-date-picker
        v-model="time"
        round
        type="date"
        class="filter-item"
        value-format="timestamp"
        placeholder="创建时间">
      </el-date-picker>
      <Btn
        btnText="搜索"
        className="primary"
        :fontSize="14"
        :width="72"
        :height="40"
        @handleClick="getList"
      />
    </div>
    <div class="list">
      <!-- 专业 -->
      <template v-if="$eduType === '专业'">
        <div v-for="item of list" :key="item.id" class="item">
          <div class="top-box">
            <div class="top-info">
              <el-row>
                <el-col :span="8" class="field"><label>专业编号：</label>{{item.number}}</el-col>
                <el-col :span="8" class="field"><label>专业名称：</label>{{item.name}}</el-col>
                <el-col :span="8" class="field"><label>专业层次：</label>{{professionalLevels[item.professionalLevel]}}</el-col>
              </el-row>
              <el-row class="field-row">
                <el-col :span="8" class="field"><label>学制：</label>{{item.year}}</el-col>
                <el-col :span="8" class="field"><label>是否全日制：</label>{{item.fullTime ? '全日制' : '非全日制'}}</el-col>
                <el-col :span="8" class="field"><label>添加时间：</label>{{item.createDate | parseTime('{y}-{m}-{d} {h}:{i}')}}</el-col>
              </el-row>
            </div>
            <div class="line"></div>
            <div class="btn-box">
              <el-link type="primary" class="btn-item" @click="handCreate(item.id)">编辑</el-link>
              <el-link v-if="item.empty" type="primary" class="btn-item" @click="handDel(item.id)">删除</el-link>
            </div>
          </div>
          <el-row class="field-row field"><label>专业描述：</label>{{item.remark}}</el-row>
        </div>
      </template>
      <!-- 产品 -->
      <template v-if="$eduType === '产品'">
        <div v-for="item of list" :key="item.id" class="item">
          <div class="top-box">
            <div class="top-info">
              <el-row>
                <el-col :span="8" class="field"><label>产品编号：</label>{{item.number}}</el-col>
                <el-col :span="8" class="field"><label>产品名称：</label>{{item.name}}</el-col>
                <el-col :span="8" class="field"><label>添加时间：</label>{{item.createDate | parseTime('{y}-{m}-{d} {h}:{i}')}}</el-col>
              </el-row>
              <el-row class="field-row field"><label>产品描述：</label>{{item.remark}}</el-row>
            </div>
            <div class="line"></div>
            <div class="btn-box">
              <el-link type="primary" class="btn-item" @click="handCreate(item.id)">编辑</el-link>
              <el-link v-if="item.empty" type="primary" class="btn-item" @click="handDel(item.id)">删除</el-link>
            </div>
          </div>
        </div>
      </template>
    </div>

    <pagination
      v-if="total>0"
      :total="total"
      :page.sync="listQuery.current"
      :limit.sync="listQuery.size"
      class="no-print"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Btn from "../../components/Btn.vue";
import { list, del } from "@/api/business";
import { parseTime } from '@/utils'
import { educationalType } from '@/utils/mixins'
import Pagination from '../../components/Pagination.vue';
export default {
  components: { Btn, Pagination },
  inject: ['$setTitle'],
  filters: {
    parseTime,
  },
  mixins: [educationalType],
  data() {
    return {
      listQuery: {
        current: 1,
        size: 10,
        keyWord: '',
        level: 1
      },
      list: [],
      total: 0,

      time: undefined,
      professionalLevels: ['专科', '本科', '硕士研究生', '博士研究生']
    };
  },
  watch: {
    time(val) {
      console.log(val)
      if (val) {
        this.listQuery.startDate = val / 1000
        this.listQuery.endDate = val / 1000 + 86400
      } else {
        this.listQuery.startDate = undefined
        this.listQuery.endDate = undefined
      }
      // this.getList()
    }
  },
  created() {
    this.$setTitle(`教育${this.$eduType}管理`)
    this.getList();
  },
  methods: {
    getList() {
      list(this.listQuery).then(res => {
        this.list = res.data.d.records;
        this.total = res.data.d.total
      });
    },
    handCreate(id) {
      if (this.$eduType === '专业') {
        this.$router.push({
          path: '/educational/addProfessional',
          query: {id}
        })
      }
      if (this.$eduType === '产品') {
        this.$router.push({
          path: '/educational/addProduct',
          query: {id}
        })
      }
    },
    handDel(id) {
      this.$_confirm({
        message: `确定要删除该${this.$eduType}吗？删除后该${this.$eduType}下面所有的学生信息将会被删除！`,
        confirm: () => {
          del({id}).then(res => {
            this.$_message({
              message: '删除成功!'
            })
            this.getList()
          })
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.title-box{
  position: relative;
  .create-btn{
    position: absolute;
    right: 0;
    bottom: 35px;
  }
}
.filter-box{
  margin-bottom: 23px;
}
.list{
  .item{
    margin-bottom: 20px;
    border: 1px solid #F1F1F1;
    box-sizing: border-box;
    padding: 30px 34px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #393939;
    .top-box{
      display: flex;
      align-items: center;

      .top-info{
        width: 100%;
      }
      .line{
        width: 1px;
        height: 40px;
        background: #DFE3E8;
      }
      .btn-box{
        width: 76px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .btn-item{
          margin-top: 15px;
          &:first-child{
            margin-top: 0;
          }
        }
      }
    }
    .field-row{
      margin-top: 30px;
    }
    .field{
      display: flex;
    }
    label{
      color: #6E6E6E;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/educational/list.vue